<mat-card appearance="outlined" class="information-card">
  <div class="header row">
    <h2>Group Information</h2>
  </div>
  <div class="info-row row">
    @for (info of groupInfo; track $index) {
      <div class="info">
        <div class="label">{{ info.label }}</div>
        <div
          class="text"
          [ngClass]="info.class?.(websiteData())"
          [matTooltip]="info.tooltip?.(websiteData())"
          [routerLink]="info.routerLink?.(websiteData())"
        >
          {{ info.text(websiteData()) }}
          @if (info.class?.(websiteData())?.includes('link')) {
            <fa-icon [icon]="['fas', 'arrow-up-right-from-square']" size="sm"></fa-icon>
          }
        </div>
      </div>
    }
  </div>
  <div class="buttons-row row">
    <button matButton="outlined">
      <fa-icon [icon]="['fas', 'arrow-up-right-from-square']" size="sm"></fa-icon>
      Open Hostbill
    </button>
    <button
      matButton="outlined"
      [cdkCopyToClipboard]="'This is the text I want to copy!'"
      (cdkCopyToClipboardCopied)="onCopied($event)"
    >
      <fa-icon [icon]="['fas', 'copy']" size="sm"></fa-icon>
      Copy SSH login
    </button>

    <button
      matButton="outlined"
      matTooltip="Add websites, check usage, create terminated backup, and control more group settings."
      [matTooltipShowDelay]="500"
      matTooltipPosition="above"
      [routerLink]="['/group', websiteData().websiteGroup?.id]"
    >
      <fa-icon [icon]="['fas', 'arrow-right-long']" size="lg"></fa-icon>
    </button>
  </div>
</mat-card>
